import React, { Fragment } from 'react';
import { Form, FormGroup, Input } from 'reactstrap';

const Search = ({ value, placeholder = "Search...", onChange}) => {
  return (
    <Fragment>
        <Input
          type="search"
          placeholder={placeholder}
          className=""
          value={value}
          onChange={onChange}
        />
    </Fragment>
  );
};

export default Search;
